import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import api from '@/api/registration';
import { ListOption } from '@/interfaces/registration/ListOption';

@Module({ namespaced: true })

class Utils extends VuexModule {
  public days: Array<ListOption> = [];
  public months: Array<ListOption> = [];
  public countries: Array<ListOption> = [];
  public states: Array<ListOption> = [];
  public genders: Array<ListOption> = [];
  public userAvatars: Array<ListOption> = [];
  public years: Array<ListOption> = [];
  public educationRelationships: Array<ListOption> = [];
  public privacyLevels: Array<ListOption> = [];
  public fetchedLists = false;

  @Mutation
  public saveUtilities (payload: { data: any }): void {
    this.fetchedLists = true;
    this.days = payload.data.days;
    this.months = payload.data.months;
    this.countries = payload.data.countries;
    this.states = payload.data.states;
    this.genders = payload.data.genders;
    this.userAvatars = payload.data.userAvatars;
    this.years = payload.data.years;
    this.educationRelationships = payload.data.educationRelationships;
    this.privacyLevels = payload.data.privacyLevels;
  }

  @Action
  public loadUtilities (): Promise<boolean> {
    if (this.fetchedLists) {
      return Promise.resolve(true);
    } else {
      return api
        .get('/account/register/utilities/')
        .then(response => {
          this.context.commit('saveUtilities', { data: response.data });
          return true;
        });
    }
  }
}

export default Utils;
